<template>
  <div class="card-sty">
    <v-card :width="cardProps.card_maxwidth" :height="cardProps.card_maxheight" class="card-shadow" >
	<div class="text-center text-sm-subtitle-1">{{ this.cardProps.component_name }}</div>

      <v-card-text>
        <div >
          <div  :class="[{battery_class:this.cardProps.widget_type=='battery'},{container_class:this.cardProps.widget_type=='cylinder'}]">
            <progress-bar :options="options" :value="value" :class="[{verticalBatteryClass:this.cardProps.rotate_widget}  ]"/>
          </div>
        </div>
          <v-card-text></v-card-text>
            <h5 style="font-size: small; font-weight: bold; margin-top: -30px;
                          text-align: center" v-if="this.cardProps.hide_widget_text == true">
          {{ cardProps.originalValue }}%
        </h5>
        
          <h6 style="font-size: -small; text-align: center; ">
            {{ cardProps.timestamp }}
          </h6>
        
     
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import VueApexCharts from "vue-apexcharts";
export default {
  name: "progressComponent",
  props: ["cardProps"],
  components: {
    // apexchart: VueApexCharts,
  },
  data: function() {
    return {
      value: this.cardProps.originalValue || 0,
      options: {
        width: 0,
        text: {
          color: this.cardProps.barTextColor || "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: this.cardProps.barTextfontSize || 14,
          fontFamily: "Helvetica",
          dynamicPosition: this.cardProps.barTextDynamicPosition || false,
          hideText: this.cardProps.hide_widget_text ,
          transform:'rotate(270deg)'
        },
        progress: {
          color: this.cardProps.widget_foreground_color || "#008FFB",
          backgroundColor: this.cardProps.widget_background_color || "#C0C0C0",
        },
        layout: {
          height: this.cardProps.widget_height || 35,
          width: this.cardProps.widget_width || 90,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 0,
          progressPadding: 0,
          type: this.cardProps.widget_type || "line",
        },
      },	  
    };
  },
  methods: {
    checkbattery (battery){
      console.log("checking battery level",this.cardProps);
      let your_string = 'Battery Level';
      if (your_string.indexOf(battery) > -1)
{
  return true
}
else{
  return false
}
    }
  },
  beforeMount() {
    console.log("checking in progress comp before mount", this.cardProps);
  },
  mounted() {
    console.log(
      "checking in progress comp on mount ",
      this.cardProps.originalValue
    );

    this.intervalid = setInterval(() => {
      this.value = this.cardProps.originalValue;
    }, 60);
	
  
  },
  afterMount() {
    console.log("checking in progress comp on mount ", this.cardProps);
  },
};
</script>

<style scoped>
@media only screen and (max-width: 1280px) {
  .card-sty {
    /* text-align: center; */
    margin: 0px 10px 5px 5px;
  }
}
@media only screen and (min-width: 1281px) and (max-width: 1366px) {
  .card-sty {
    /* text-align: center; */
    margin: 0px 10px 5px 10px;
  }
}
@media only screen and (min-width: 1367px) and (max-width: 1440px) {
  .card-sty {
    /* text-align: center; */
    margin: 0px 10px 5px 10px;
  }
}
@media only screen and (min-width: 2560px) and (max-width: 2560px) {
  .card-sty {
    /* text-align: center; */
    margin: 0px 10px 5px 10px;
  }
}
@media only screen and (min-width: 1921px) and (max-width: 2559px) {
  .card-sty {
    /* text-align: center; */
    margin: 0px 10px 5px 10px;
  }
  .chartClass1 {
    margin-left: 15px;
  }
}
@media only screen and (min-width: 1441px) and (max-width: 1920px) {
  .insigDim {
    margin-right: -85px;
    margin-left: -80px;
  }
}
#gauge-card {
  /* border-style: solid ;
    border-radius: 15px;
      border-color: #a7a7a7; */
}
.item2 {
  font-family: "EMPrint";
  font-size: 16px;
  font-weight: bold;
}
.minClass {
  font-size: small;
  font-weight: bolder;
  text-align: center;
  margin: -20px 50px -5px -60px;
}
.minClass1 {
  font-size: small;
  font-weight: bolder;
  text-align: center;
  margin: -20px 140px -5px -60px;
}
.maxClass {
  font-size: small;
  font-weight: bolder;
  text-align: center;
  margin: -22px -200px 0px -80px;
}
.maxClass1 {
  font-size: small;
  font-weight: bolder;
  text-align: center;
  margin: -22px -300px 0px -80px;
}

.verticalBatteryClass {
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg); 
  -o-transform: rotate(270deg);
  -ms-transform: rotate(270deg); 
  transform: rotate(270deg);
} 
.battery_class {
  margin-top:100px;
  margin-left:60px;
    margin-bottom:-32px;

}
.container_class{
  margin-left:-5px;
  margin-top:0px;
  margin-bottom: -3px;


}
          
</style>
